"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _constants = require("./constants");
var _Tabs = _interopRequireDefault(require("./Tabs.style"));
var _TabHeader = _interopRequireDefault(require("./header/TabHeader"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Tabs = /*#__PURE__*/function (_React$Component) {
  _inherits(Tabs, _React$Component);
  var _super = _createSuper(Tabs);
  function Tabs(props) {
    var _this;
    _classCallCheck(this, Tabs);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleTabClick", function (tabIndex, allowNavigation) {
      var _this$props = _this.props,
        controlledTabNavigation = _this$props.controlledTabNavigation,
        onTabChange = _this$props.onTabChange;
      if (!controlledTabNavigation) {
        _this.setState({
          activeTabIndex: tabIndex
        });
      }
      if (onTabChange && allowNavigation) onTabChange(tabIndex, _this.state.activeTabIndex);
    });
    // eslint-disable-next-line react/no-unused-class-component-methods
    _defineProperty(_assertThisInitialized(_this), "moveToNextTab", function () {
      var _this$state = _this.state,
        activeTabIndex = _this$state.activeTabIndex,
        noOfTabs = _this$state.noOfTabs;
      var onTabChange = _this.props.onTabChange;
      if (activeTabIndex < noOfTabs - 1) {
        var newTabIndex = activeTabIndex + 1;
        _this.setState({
          activeTabIndex: newTabIndex
        });
        if (onTabChange) onTabChange(newTabIndex, activeTabIndex);
      }
    });
    // eslint-disable-next-line react/no-unused-class-component-methods
    _defineProperty(_assertThisInitialized(_this), "moveToPreviousTab", function () {
      var activeTabIndex = _this.state.activeTabIndex;
      var onTabChange = _this.props.onTabChange;
      if (activeTabIndex !== 0) {
        var newTabIndex = activeTabIndex - 1;
        _this.setState({
          activeTabIndex: newTabIndex
        });
        if (onTabChange) onTabChange(newTabIndex, activeTabIndex);
      }
    });
    // eslint-disable-next-line react/no-unused-class-component-methods
    _defineProperty(_assertThisInitialized(_this), "moveToSelectedTab", function (index) {
      _this.setState({
        activeTabIndex: index
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderContent", function () {
      var children = _this.props.children.filter(function (item) {
        return item;
      }); // remove falsy values
      var activeTabIndex = _this.state.activeTabIndex;
      if (children[activeTabIndex]) {
        return children[activeTabIndex].props.children;
      }
      return null;
    });
    var _noOfTabs = props.children ? props.children.length : 0;
    _this.state = {
      activeTabIndex: props.defaultActiveTabIndex,
      noOfTabs: _noOfTabs
    };
    return _this;
  }
  _createClass(Tabs, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        alignment = _this$props2.alignment,
        noMargins = _this$props2.noMargins,
        children = _this$props2.children,
        view = _this$props2.view,
        className = _this$props2.className,
        controlledTabNavigation = _this$props2.controlledTabNavigation,
        isWizzard = _this$props2.isWizzard,
        headerExtra = _this$props2.headerExtra;
      return /*#__PURE__*/_react["default"].createElement(_Tabs["default"], {
        className: className,
        hasExtra: !(0, _utils.isBlank)(headerExtra)
      }, children && /*#__PURE__*/_react["default"].createElement(_TabHeader["default"], {
        view: view,
        alignment: alignment,
        noMargins: noMargins,
        isWizzard: isWizzard,
        controllable: controlledTabNavigation
      }, _react["default"].Children.map(_react["default"].Children.toArray(children), function (child, index) {
        return /*#__PURE__*/_react["default"].cloneElement(child, {
          onClick: _this2.handleTabClick,
          tabIndex: index,
          isActive: index === _this2.state.activeTabIndex,
          isWizzard: isWizzard,
          controlledTabNavigation: controlledTabNavigation,
          view: view
        });
      })), headerExtra && /*#__PURE__*/_react["default"].createElement("div", {
        className: "header-extra"
      }, headerExtra), children && /*#__PURE__*/_react["default"].createElement("div", {
        className: "tabs-active-content"
      }, this.renderContent()));
    }
  }]);
  return Tabs;
}(_react["default"].Component);
Tabs.propTypes = {
  view: _propTypes["default"].oneOf(R.values(_constants.VIEW_TYPE)),
  defaultActiveTabIndex: _propTypes["default"].number,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  headerExtra: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  controlledTabNavigation: _propTypes["default"].bool,
  alignment: _propTypes["default"].string,
  noMargins: _propTypes["default"].bool,
  isWizzard: _propTypes["default"].bool,
  onTabChange: _propTypes["default"].func,
  className: _propTypes["default"].string
};
Tabs.defaultProps = {
  onTabChange: function onTabChange() {},
  defaultActiveTabIndex: 0,
  controlledTabNavigation: false,
  alignment: _constants.ALIGNMENT_MAP.center,
  noMargins: false,
  children: null,
  headerExtra: null,
  isWizzard: false,
  className: 'Tabs-container',
  view: _constants.VIEW_TYPE["default"]
};
Tabs.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleTabClick",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "tabIndex",
      "type": null
    }, {
      "name": "allowNavigation",
      "type": null
    }],
    "returns": null
  }, {
    "name": "moveToNextTab",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "moveToPreviousTab",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "moveToSelectedTab",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }],
    "returns": null
  }, {
    "name": "renderContent",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Tabs",
  "props": {
    "onTabChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "defaultActiveTabIndex": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "controlledTabNavigation": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "alignment": {
      "defaultValue": {
        "value": "ALIGNMENT_MAP.center",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "noMargins": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "children": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "arrayOf",
          "value": {
            "name": "node"
          }
        }, {
          "name": "node"
        }]
      },
      "required": false
    },
    "headerExtra": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "arrayOf",
          "value": {
            "name": "node"
          }
        }, {
          "name": "node"
        }]
      },
      "required": false
    },
    "isWizzard": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "'Tabs-container'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "view": {
      "defaultValue": {
        "value": "VIEW_TYPE.default",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "enum",
        "computed": true,
        "value": "R.values(VIEW_TYPE)"
      },
      "required": false
    }
  }
};
var _default = Tabs;
exports["default"] = _default;